(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/kambi-offering/assets/javascripts/hooks/use-kambi-bet-offers.js') >= 0) return;  svs.modules.push('/components/oddset/kambi-offering/assets/javascripts/hooks/use-kambi-bet-offers.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useReducer = _React.useReducer,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect;
const _svs$components$oddse = svs.components.oddset.kambiOffering,
  _svs$components$oddse2 = _svs$components$oddse.common.normalize,
  normalizeBetOffers = _svs$components$oddse2.normalizeBetOffers,
  normalizeSocketMessages = _svs$components$oddse2.normalizeSocketMessages,
  _svs$components$oddse3 = _svs$components$oddse.store,
  reducer = _svs$components$oddse3.reducer,
  initState = _svs$components$oddse3.initState,
  ActionType = _svs$components$oddse3.ActionType,
  useBetOfferSockets = _svs$components$oddse.hooks.useBetOfferSockets,
  getBetOffers = _svs$components$oddse.getBetOffers;
const useInterval = svs.components.lbUtils.useInterval;
const logger = svs.core.log.getLogger('components:oddset:kambi-offerings:hooks:useKambiBetOffers');
const useKambiBetOffers = _ref => {
  let kambiEventId = _ref.kambiEventId,
    betOfferTypesArr = _ref.betOfferTypesArr,
    englishLabelsArr = _ref.englishLabelsArr,
    _ref$shouldConnectSoc = _ref.shouldConnectSockets,
    shouldConnectSockets = _ref$shouldConnectSoc === void 0 ? true : _ref$shouldConnectSoc,
    _ref$pollingDelay = _ref.pollingDelay,
    pollingDelay = _ref$pollingDelay === void 0 ? 15 * 1000 : _ref$pollingDelay;
  const _useReducer = useReducer(reducer, initState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    resetPolling = _useState6[0],
    setResetPolling = _useState6[1];
  const intervalId = useInterval(() => {
    const fetchBetOffers = async () => {
      if (!kambiEventId || !(betOfferTypesArr !== null && betOfferTypesArr !== void 0 && betOfferTypesArr.length) || !(englishLabelsArr !== null && englishLabelsArr !== void 0 && englishLabelsArr.length)) {
        logger.error('Missing parameters in useKambiBetOffers hook.');
        return;
      }
      setIsLoading(true);
      const response = await getBetOffers(kambiEventId, betOfferTypesArr);
      const betOffersRes = response.betOffers,
        error = response.error;
      if (error) {
        logger.error("Error fetching betOffers for event ".concat(kambiEventId), error);
        setError(error);
        setIsLoading(false);
        return;
      }
      const normalizedBetOffers = englishLabelsArr.reduce((acc, englishLabel) => {
        const filteredOffers = betOffersRes.filter(betOffer => betOffer.criterion.englishLabel === englishLabel);
        const normalized = normalizeBetOffers(filteredOffers, response);
        normalized.forEach(betOffer => {
          acc[betOffer.id] = betOffer;
        });
        return acc;
      }, {});
      dispatch({
        type: ActionType.SetBetOffers,
        payload: normalizedBetOffers
      });
      setIsLoading(false);
    };
    fetchBetOffers();
  }, pollingDelay, true, resetPolling);
  useEffect(() => {
    clearTimeout(intervalId);
    setResetPolling(value => value + 1);
  }, [kambiEventId]);
  const onSocketMessageCallback = useCallback(messageArr => {
    clearTimeout(intervalId);
    const normalizedMessages = normalizeSocketMessages(messageArr);
    normalizedMessages.forEach(message => {
      dispatch({
        type: message.type,
        payload: message.payload
      });
    });
    setResetPolling(value => value + 1);
  }, [intervalId]);
  useBetOfferSockets(kambiEventId, onSocketMessageCallback, shouldConnectSockets);
  return {
    betOffers: state,
    error,
    isLoading
  };
};
setGlobal('svs.components.oddset.kambiOffering.hooks.useKambiBetOffers', useKambiBetOffers);

 })(window);